import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { RejectService } from './services/reject.service';
import { ClaimDto } from 'src/app/auto-generated-server-dtos/adjuster/claim/claim-dto';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Utils from 'src/app/helpers/utils';
import { RepairDto } from 'src/app/auto-generated-server-dtos/adjuster/claim/repairs/models/repair-dto';
import { SetUpdateForRepairCentreService } from '../../services/set-update-for-repair-centre.service';
import { concatMap } from 'rxjs';

@Component({
  selector: 'app-reject-modal',
  templateUrl: './reject-modal.component.html',
  styleUrl: './reject-modal.component.scss'
})
export class RejectModalComponent {
  @Input() claimDto!: ClaimDto;
  @Input() repairsDto!: RepairDto[];
  @Input() repairTotal!: number;
  @Input() customerRecordMatch = false;

  @Output() refreshClaim = new EventEmitter<void>();
  
  finalMessage: string = "";
  
  isBusy: boolean = false;
  showSuccess: boolean = false;
  isError: boolean = false;
  isFinalMessageValid: boolean = true;
  
  e2Url: string = "";

  constructor(
      private rejectService: RejectService, 
      private utils: Utils, 
      public activeModal: NgbActiveModal,
      private setUpdateForRepairCentreService: SetUpdateForRepairCentreService
  ) {
  }

  rejectClaim() {
    this.validateFinalMessage();
    if (this.isFinalMessageValid) {
      this.isBusy = true;
      this.setUpdateForRepairCentreService.SetUpdateForRepairCentre(this.claimDto.claimId).pipe(
        concatMap(() => this.rejectService.reject(this.claimDto.claimId, this.finalMessage))
      ).subscribe({
        next: () => {
          this.isBusy = false;
          const enterpriseId = this.utils.parseAuthorizationNumber(this.claimDto.authorizationNumber!);
          this.e2Url = `https://e2.eazeetrak.com/claims/${enterpriseId}/detail`
          this.showSuccess = true;
          this.refreshClaim.emit();
        }, 
        error: (err) => {
          this.isBusy = false;
          this.isError = true;
          this.refreshClaim.emit();
        }
      })
    }
  }

  validateFinalMessage(): void {
    this.isFinalMessageValid = this.finalMessage.length > 0;
  }
  
}
